import React, {useEffect, useMemo, useState} from 'react';
import moment from 'moment';
import API from "../../../utils/API";
import {API_ENDPOINTS} from "../../../apiConfig";
import Forms from "../../../components/Forms";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import {useModal} from "../../../contexts/ModalContext";
import DiagnosticCatalogModal from "../../../components/DiagnosticCatalogModal";
import AdminDataView from "../../../components/AdminDataView";

const ANSWER_TYPE_LABELS = {
    status: 'Netestováno | Funkční | Nefunkční',
    number: 'Číselná odpověď',
    grade: 'A | B | C'
};

const DiagnosticCatalog = () => {
    const [items, setItems] = useState([]);
    const [error, setError] = useState();
    const {openModal, confirm} = useModal();

    const fetchItems = async () => {
        const response = await API.get(API_ENDPOINTS.diagnosticCatalog.list);
        setItems(response.data || []);
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const confirmDelete = async (item) => {
        const result = await confirm(`Opravdu chcete smazat položku "${item.name}"?`);
        if (result !== true) return;
        try {
            await API.delete(API_ENDPOINTS.diagnosticCatalog.delete(item._id));
            setItems((prev) => prev.filter((row) => row._id !== item._id));
        } catch (err) {
            setError(err);
        }
    };

    const openItemModal = (item = null) => {
        openModal(DiagnosticCatalogModal, {item, onUpdate: fetchItems}, {title: item ? 'Úprava položky diagnostiky' : 'Nová položka diagnostiky'});
    };

    const columns = useMemo(() => ([
        {
            key: 'name',
            name: 'Název',
            minWidth: 260,
            renderCell: ({row}) => <label className="label">{row.name}</label>
        },
        {
            key: 'answerType',
            name: 'Typ odpovědi',
            minWidth: 220,
            renderCell: ({row}) => ANSWER_TYPE_LABELS[row.answerType] || row.answerType
        },
        {
            key: 'createdBy',
            name: 'Vytvořil',
            minWidth: 140,
            renderCell: ({row}) => `${row?.createdBy?.name || ''} ${row?.createdBy?.surname || ''}`.trim() || '-'
        },
        {
            key: 'createdAt',
            name: 'Vytvořeno',
            minWidth: 150,
            renderCell: ({row}) => row.createdAt ? moment(row.createdAt).format('DD.MM.YYYY HH:mm') : '-'
        },
        {
            key: 'actions',
            name: 'Akce',
            width: 110,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit položku diagnostiky" onClick={() => openItemModal(row)}/>
                    <DeleteIconButton title="Smazat položku diagnostiky" onClick={() => confirmDelete(row)}/>
                </div>
            )
        }
    ]).map((column) => ({...column, resizable: true})), []);

    return (
        <div>
            <Forms.Button label="Přidat položku diagnostiky" onClick={() => openItemModal()} className="mb-8"/>
            {error ? <div className="text-sm text-red-600 mb-3">{error?.message || 'Nepodařilo se načíst data.'}</div> : null}
            <AdminDataView section="diagnostic-catalog" rows={items} columns={columns}/>
        </div>
    );
};

export default DiagnosticCatalog;
